module.exports = __webpack_public_path__ + "components/Header/logo-small.png?2f751285";


//////////////////
// WEBPACK FOOTER
// ./components/Header/logo-small.png
// module id = 831
// module chunks = 0